import dayjs from 'dayjs'
import { useMemo, useState } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import DeleteConfirmationDialog from '@/components/ui/dialogs/DeleteConfirmationDialog'

import { useDeleteApiKeyMutation, useGetApiKeysQuery } from '@/core/api'

import { getApiErrorMessage } from '@/utils/errors'

import ApiKeysTable from '../components/ApiKeysTable'

export default function ApiKeysTableContainer() {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const { data: apiKeys, isLoading: isFetchingApiKeys } = useGetApiKeysQuery()
  const [deleteApiKey, { isLoading: isDeletingApikey }] = useDeleteApiKeyMutation()

  const apiKeysData = useMemo(
    () =>
      apiKeys?.map((apiKey) => ({
        id: apiKey._id,
        createdAt: dayjs(apiKey.createdAt).format('DD/MM/YYYY'),
        name: apiKey.name ?? '',
        prefix: apiKey.prefix,
      })) ?? [],
    [apiKeys]
  )

  const [deletingApiKeyId, setDeletingApiKeyId] = useState<string>()
  const [openDeleteConfirmationDialog, setOpenDeleteConfirmationDialog] = useState(false)

  return (
    <>
      <ApiKeysTable
        data={apiKeysData}
        loading={isFetchingApiKeys}
        onDeleteClick={(apiKeyId) => {
          setDeletingApiKeyId(apiKeyId)
          setOpenDeleteConfirmationDialog(true)
        }}
      />
      <DeleteConfirmationDialog
        isDeleting={isDeletingApikey}
        maxWidth={800}
        onClose={() => {
          setOpenDeleteConfirmationDialog(false)
        }}
        onDelete={async () => {
          if (deletingApiKeyId) {
            try {
              await deleteApiKey(deletingApiKeyId).unwrap()
            } catch (error) {
              enqueueSnackbar(getApiErrorMessage(error, t('notification.apiKey.delete.error')), { variant: 'error' })
            }
            setDeletingApiKeyId(undefined)
            setOpenDeleteConfirmationDialog(false)
          }
        }}
        open={openDeleteConfirmationDialog}
        title={t('dialog.deleteConfirmation.apiKey.title')}
        message={t('dialog.deleteConfirmation.apiKey.message')}
      />
    </>
  )
}
